import { Box, Tab, Tabs, Typography, useTheme } from "@mui/material";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import MessageStore from "components/ManagerInteractions/Stores/MessageStore";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import LLMManagementStore from "stores/LLMManagementStore";
import { useStore } from "utils/useStore";
import EmbeddingModelsTable from "./EmbeddingModelsTable";
import HostsTable from "./HostsTable";
import LLMModelsTable from "./LLMModelsTable";
import OrganizationBreadcrumbs from "../OrganizationBreadcrumbs";

const OrganizationAIModels: React.FC = observer(() => {
    const theme = useTheme();
    const store = useStore(LLMManagementStore);
    const messageStore = useStore(MessageStore);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        store.loadAll().catch((err: unknown) => {
            const msg =
                err instanceof Error
                    ? err.message
                    : "Failed to load AI Models data";
            messageStore.logError(msg);
        });
    }, [store, messageStore]);

    return (
        <Box
            sx={{
                padding: 4,
                maxWidth: `calc(100% - ${theme.spacing(4)})`,
                width: "1200px",
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >
            <OrganizationBreadcrumbs pageTitle="AI Models" />
            <Typography
                sx={{
                    fontSize: "24px",
                    fontWeight: 600,
                    color: theme.palette.gray[700],
                    mt: 2,
                }}
            >
                AI Models
            </Typography>

            {store.isLoading ? (
                <AcxLoadingIndicator alternate="PuffLoader" size={64} />
            ) : (
                <>
                    <Tabs
                        value={activeTab}
                        onChange={(_e, val: number) => setActiveTab(val)}
                        sx={{
                            borderBottom: 1,
                            borderColor: "divider",
                        }}
                    >
                        <Tab label="Hosts" />
                        <Tab label="LLM Models" />
                        <Tab label="Embedding Models" />
                    </Tabs>
                    {activeTab === 0 && <HostsTable store={store} />}
                    {activeTab === 1 && <LLMModelsTable store={store} />}
                    {activeTab === 2 && <EmbeddingModelsTable store={store} />}
                </>
            )}
        </Box>
    );
});

export default OrganizationAIModels;
